import inRange from 'lodash/inRange';
import { DateTime } from 'luxon';

const MAX_DAY = 32; // Exclusive maximum number of days in a month
const MAX_MONTH = 13; // Exclusive number of months in a year

export const isValidDayInput = (dayValueArg: string) => {
  if (dayValueArg === '00') {
    return false;
  }

  return !dayValueArg || inRange(Number(dayValueArg), 0, MAX_DAY);
};

export const isValidMonthInput = (monthValueArg: string) => {
  if (monthValueArg === '00') {
    return false;
  }

  return !monthValueArg || inRange(Number(monthValueArg), 0, MAX_MONTH);
};

// Ensures the inputted year is not in the future
export const isValidYearInput = (yearValueArg: string) =>
  !yearValueArg || inRange(Number(yearValueArg), 1, DateTime.utc().year + 1);

export const getInitialDateValues = (date: Date | null) => {
  if (date && DateTime.fromJSDate(date).isValid) {
    return {
      monthValue: (date.getUTCMonth() + 1).toString(),
      dayValue: date.getUTCDate().toString(),
      yearValue: date.getUTCFullYear().toString(),
    };
  }

  return {
    monthValue: '',
    dayValue: '',
    yearValue: '',
  };
};
